export const HM_LOGIN_PROFILE_KEY = "hm_login_profile";
export function mapLoginResultToUserDto(result) {
    return {
        id: result.user_id,
        firstName: result.firstName || "",
        lastName: result.lastName || "",
        email: result.email || "",
        phoneNumber: result.phoneNumber || "",
        profileImage: result.profileImage || "",
        role: result.role,
    };
}
export function persistManagerLoginProfile(result) {
    const profile = {
        id: result.user_id,
        firstName: result.firstName || "",
        lastName: result.lastName || "",
        email: result.email || "",
        role: result.role,
    };
    sessionStorage.setItem(HM_LOGIN_PROFILE_KEY, JSON.stringify(profile));
    return profile;
}
export function readManagerLoginProfile() {
    try {
        const raw = sessionStorage.getItem(HM_LOGIN_PROFILE_KEY);
        if (!raw)
            return null;
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
export function applyManagerLoginToContext(result, setUser) {
    persistManagerLoginProfile(result);
    setUser(mapLoginResultToUserDto(result));
}
export function hydrateManagerUserFromStorage(setUser) {
    const profile = readManagerLoginProfile();
    if (!profile)
        return;
    setUser(mapLoginResultToUserDto(profile));
}
export function getFeedbackSubmittedByName(user) {
    const fromContext = [user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
    if (fromContext)
        return fromContext;
    const stored = readManagerLoginProfile();
    return [stored === null || stored === void 0 ? void 0 : stored.firstName, stored === null || stored === void 0 ? void 0 : stored.lastName].filter(Boolean).join(" ").trim();
}
export function getManagerEmailFromContext(user) {
    var _a, _b, _c;
    if ((_a = user === null || user === void 0 ? void 0 : user.email) === null || _a === void 0 ? void 0 : _a.trim())
        return user.email.trim();
    return ((_c = (_b = readManagerLoginProfile()) === null || _b === void 0 ? void 0 : _b.email) === null || _c === void 0 ? void 0 : _c.trim()) || "";
}
